import React from 'react';
import { Grid, Image,Icon } from 'semantic-ui-react';
import { NavLink, Link } from 'react-router-dom';
import { useSelector} from 'react-redux'
import WhatsAppWidget from "react-whatsapp-chat-widget";
import { Button } from 'semantic-ui-react';
import "react-whatsapp-chat-widget/index.css";
import useGlobalConfig from '../../hooks/globalConfig';
const Fotterpage = () => {
 
  const {siteName, img5} = useGlobalConfig()
  const activo = useSelector(store => store.usuario.activo)
  return (
    <div className=
    {
      activo ? (
        'footerpageback nevershow'
      ) : (
        'footerpageback'
      )
      }
    >
      <div className='footerpage'>
    <Grid>

    <Grid.Column computer={3} mobile={8} tablet={4}  >
    <Image className="foo brandsLogo" src={img5} />

     </Grid.Column >

    <Grid.Column computer={7} mobile={8} tablet={8} className="footer-cards" >
        <div id="menufootercenter">
            
            <span>
            <h3>Contacto</h3>
                <p>
                <a  className="nonstyle" href='tel:+56971285894' >
                <Icon color='purple' name='phone' /> 
                +56 9 7128 5894
                  </a >
                <br />
                <a  className="nonstyle" href='https://api.whatsapp.com/send?phone=56971285894&text=Hola%20estoy%20interesado'  >
                <Icon color='purple' name='whatsapp' /> 
                +56 9 7128 5894
                </a >   
                
                <br />
                <a  className="nonstyle" href='mailto:contacto@bicciexpress.cl' >
                <Icon color='purple' name='mail' /> 
                contacto@bicciexpress.cl
                </a >
                <br />
                <a  className="nonstyle" href="#" >
                <Icon color='purple' name='periscope' /> 
                Región Metropolitana. CHILE  
                </a >
                </p>
            </span>  
           
          </div>
       
     </Grid.Column >
 
    <Grid.Column computer={5} mobile={16} tablet={4} className="footer-cards" >
        <div id="menufootercenter2">
               
            <span>
            <div> <Icon color='purple' name='ellipsis vertical' className="footer-btn-menu" />  Menú </div>
                <p className="foo-inline-flex">
                
                <NavLink  to="/nosotros" exact><Icon color='purple' name='cubes' />    Nosotros </NavLink>
                <br />
                 
                <NavLink  to="/servicios" exact>  <Icon color='purple' name='cogs' />   Servicios </NavLink>
                <br />
                
                <NavLink  to="/contacto" exact><Icon color='purple' name='envelope open' />   Contacto </NavLink>
                <br />
               
                <NavLink  to="/terminos" exact>  <Icon color='purple' name='balance scale' />  Terminos y condiciones </NavLink>
                </p>
            </span>  
          
       </div>
       <div id="calltrap-btn" className="b-calltrap-btn calltrap_offline hidden-phone visible-tablet">
       <div id="calltrap-ico">
       </div>
       </div>
       <div>
       <WhatsAppWidget
            phoneNo="+56971285894"
            position="right"
            widgetWidth="350px"
            widgetWidthMobile="260px"
            autoOpen={true}
            autoOpenTimer={5000}
            messageBox={true}
            messageBoxTxt="Solicito información!"
            iconSize="40"
            iconColor="white"
            iconBgColor={'#47c756'}
            headerIcon={img5}
            headerIconColor="pink"
            headerTxtColor={'#fff'}
            headerBgColor={'#591e8f'}
            headerTitle={<h3>{siteName}</h3>}
            headerCaption="Electric Bicci Express"
            bodyBgColor={'#fff'}
            chatPersonName="BICCI"
            chatMessage={<>Hola 👋 <br /> Como podemos ayudarte?</>}
            footerBgColor={'#00cdf6'}
            btnBgColor={"00e676"}
            btnTxtColor={'#591e8f'}
            btnTxt={'Iniciar chat'}
      
          />

       </div>
     </Grid.Column >

    </Grid>
    </div>
    </div>
  );
};

export default Fotterpage;
